angular.module('app').controller('ClassPhotosCtrl', function($controller, $scope, $http, $mdDialog, appUtils, PhotoUtils, $mdToast) {
    "ngInject";

    var main = this;
    main.name = 'event';
    main.selected = [];
    main.photoUtils = PhotoUtils;

    $scope.$on('model-loaded', function() {
        $http.get('/api/v1/admin/event/' + main.item.id + '/class-photos').then(
            function(response) {
                main.classPhotos = response.data;
                main.classPhotos.forEach(function(photo) {
                    photo.classes = {};
                    photo.class_photos.forEach(function(cl) {
                        photo.classes[cl.class_name] = true;
                    });
                });
            }
        );

        $http({
            'method': 'GET',
            'url': '/api/v1/admin/event/' + main.item.id + '/class-names'
        }).then(function(response) {
            main.classes = response.data;
        });
    });

    angular.extend(main, $controller('ItemCtrl', {'$scope': $scope, 'main': main}));

    main.add = function() {
        PhotoUtils.uploadImage(
            '/api/v1/admin/photo',
            function(response) {
                main.classPhotos.push(response.data.photo);
            },
            {'event_id': main.item.id, 'is_class_photo': true},
            'image/jpeg'
        );
    };

    main.savePhoto = function(photo) {

        var classes = []
        for(var k in photo.classes) {
            if(photo.classes[k]) {
                classes.push({'class_name': k});
            }
        }
        photo.class_photo = classes;
        var data = {'class_photos': classes, 'id': photo.id, 'show_in_all_galleries': photo.show_in_all_galleries};
        $http.put('/api/v1/admin/photo/' + photo.id, data).then(
            function(response) {
                var alert = $mdToast.simple().textContent("Saved");
                $mdToast.show(alert);
            }
        );
    }

    main.remove = function(photo) {
        if(!confirm('Are you sure you want to delete ' + photo.filename + '?')) {
            return;
        }

        data = {'is_class_photo': false};
        $http.put('/api/v1/admin/photo/' + photo.id, data).then(
            function(response) {
                appUtils.remove(photo, 'id', main.classPhotos);
            }
        );
    }

});
